import { API_TUser } from "@/models/auth";
import axios from "@/plugins/http";
import router from "@/router";
import { SMApp, SMNotifications, SMUser } from "@/store";
import driverHttpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js";
import driverRouterVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js";
import auth from "@websanova/vue-auth/dist/v2/vue-auth.esm.js";
import Vue from "vue";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import { isMaintenanceMode } from "@/utils/methods";

Vue.router = router;

Vue.use(VueAxios, axios);

const DEFAULT_HTTP_TIMEOUT = 60;

// const REFRESH_USER_INTERVAL = 5 * 60 * 1000;

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.axios.defaults.timeout =
  ((process.env.VUE_APP_DEFAULT_HTTP_TIMEOUT || DEFAULT_HTTP_TIMEOUT) as number) * 1000;

Vue.use(auth, {
  tokenDefaultKey: "auth_token_default",
  plugins: {
    http: Vue.axios,
    router: Vue.router,
  },
  drivers: {
    auth: {
      request(req: any, token: any) {
        driverHttpAxios.setHeaders.call(this, req, {
          Authorization: `Bearer ${token}`,
        });
      },
      response(res: any) {
        return (res.data || {}).token;
      },
    },
    http: driverHttpAxios,
    router: driverRouterVueRouter,
  },
  options: {
    registerData: {
      url: "/auth/register",
      redirect: false,
      autoLogin: false,
    },
    loginData: {
      url: "/auth/login",
      redirect: false,
      fetchUser: false,
      staySignedIn: true,
    },
    authRedirect: "/auth/login",
    rolesKey: "role",
    notFoundRedirect: "/404",
    refreshData: {
      enabled: false,
      interval: 5,
    },
    fetchData: {
      url: "/current_user",
      enabled: false,
    },
    parseUserData(data: API_TUser) {
      const hasUser = !!(data && data.ID);

      hasUser ? SMUser.setUser(data) : SMUser.unsetUser();

      hasUser
        ? SMNotifications.fetchNotificationsStatus()
        : SMNotifications.stopNotificationsRefresh();

      hasUser ? SMApp.checkAuthOnServer() : SMApp.resetAuthOnServer();

      return data || {};
    },
  },
});

// Make this implementation to try fetch user as sooner, as possible;
const initVueAuthPlugin = async () => {
  const authStaySignedIn = window.localStorage.getItem("auth_stay_signed_in");

  if (!isMaintenanceMode() && authStaySignedIn) await Vue.auth?.fetch();

  // setInterval(async () => {
  //   if (isMaintenanceMode()) return;
  //
  //   await Vue.auth?.refresh();
  // }, REFRESH_USER_INTERVAL);

  SMApp.refresh(isMaintenanceMode());
};

initVueAuthPlugin().then();

declare module "vue/types/vue" {
  interface Vue {
    $auth: any;
    auth: any;
  }

  interface VueConstructor {
    router: VueRouter;
    auth: any;
  }
}
